/**
 * Enum representing the possible inspection result statuses
 */
export enum InspectionResult {
    PASS = 'Pass',
    FAIL = 'Fail',
    COMMERCIAL_PASS = 'Comm. Pass',
    PENDING = 'Pending',
    COMPLETE = 'Complete'
}
